import { render, staticRenderFns } from "./AnnouncementListSkeleton.vue?vue&type=template&id=41221c98&scoped=true&"
import script from "./AnnouncementListSkeleton.vue?vue&type=script&lang=js&"
export * from "./AnnouncementListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementListSkeleton.vue?vue&type=style&index=0&id=41221c98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41221c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41221c98')) {
      api.createRecord('41221c98', component.options)
    } else {
      api.reload('41221c98', component.options)
    }
    module.hot.accept("./AnnouncementListSkeleton.vue?vue&type=template&id=41221c98&scoped=true&", function () {
      api.rerender('41221c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InformationTab/AnnouncementListSkeleton.vue"
export default component.exports